<div class="modal-content">
    <div class="modal-header">
      <ng-container *ngIf="error">
        <img src="assets/icon/error.svg" alt="" class="me-2"/>
        <h3 class="fzas-modal-title m-0">Simulación con Errores</h3>
      </ng-container>
      <ng-container *ngIf="!error">
        <img src="assets/icon/success.svg" alt="" class="me-2"/>
        <h3 class="fzas-modal-title m-0">Simulación Realizada</h3>
      </ng-container>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="salir(false)"></button>
    </div>
  
    <div class="modal-body">
      <div class="row">
        <div class="col-12">
          <p class="fzas-text-modal-simulacion">Registros leídos: {{ datosSimulacion.centProcRegLeidos | currency:'CLP':'' }}</p>
        </div>
        <div class="col-12">
          <p [ngClass]="error ? 'fzas-text-modal-simulacion-error' : 'fzas-text-modal-simulacion'">Sumatoria Haberes: {{ datosSimulacion.centProcSumHaber | currency:'CLP':'' }}</p>
        </div>
        <div class="col-12">
          <p [ngClass]="error ? 'fzas-text-modal-simulacion-error' : 'fzas-text-modal-simulacion'">Sumatoria Deberes: {{ datosSimulacion.centProcSumDebe | currency:'CLP':'' }}</p>
        </div>
        <div class="col-12">
          <p [ngClass]="error ? 'fzas-text-modal-simulacion-error' : 'fzas-text-modal-simulacion'">Todos los entes son proveedores: {{ datosSimulacion.centProcAllProve == 0 ? 'NO' : 'SI' }}</p>
        </div>
        <ng-container *ngIf="error">
          <ng-container *ngIf="datosSimulacion.centProcKeyS3DocumentoFallo">
            <div class="col-12 mt-3 d-flex align-items-center">
              <img src="assets/icon/sheet.svg" alt="" class="me-1"/>
              <a class="fzas-text-modal-visualizacion-errores" (click)="descargarErrores(datosSimulacion.centProcKeyS3DocumentoFallo)">Descargar visualización errores</a>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  
    <div class="modal-footer">
      <div class="row">
        <div class="col-12 d-flex justify-content-end gap-3">
          <button type="button" class="btn btn-cancelar-accion" (click)="salir(false)">Cancelar</button>
                <button type="button" class="btn btn-aplicar-accion" (click)="salir(true)">Aceptar</button>
        </div>
      </div>
    </div>
  </div>
  